import embedLinkTpl from '../templates/creative_preview/embed_link.directive.html';

function EmbedLinkController(
  $scope,
  CreativeService,
  MixpanelService,
  RenderService,
  ShareableLinkService
) {
  const vm = this;
  vm.embedLink = '';
  vm.mixpanelService = MixpanelService;

  $scope.$watchGroup(
    [() => CreativeService.creative, () => RenderService.site],
    setEmbedLink
  );

  return vm;

  function setEmbedLink() {
    vm.embedLink = ShareableLinkService.buildEmbedUrl();
  }
}

EmbedLinkController.$inject = [
  '$scope',
  'CreativeService',
  'MixpanelService',
  'RenderService',
  'ShareableLinkService'
];

export default function strEmbedLink() {
  return {
    restrict: 'EA',
    template: embedLinkTpl,
    controller: EmbedLinkController,
    controllerAs: 'vm'
  };
}
